<template>
  <div class="contentRight2">
    <div class="rightHead">
      <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">收银开单</div>
    </div>
    <div class="backgroundImg">
      <div style="height:calc(100vh - 51px);width:100%;position: absolute;" class="center">
        <el-button class="button" type="primary" @click="jump">使用收银网页版</el-button>
      </div>
      <img src="../../assets/icon/cashierOrderAD.png" alt />
    </div>
  </div>
</template>
<script>
export default {
  methods:{
    jump(){
      //打开新页面
      let routeUrl = this.$router.resolve({
        path:"cashierOrder/cashierOrderHome",
        // query: {id:96}
      });
       window.open(routeUrl.href, '_blank');
    }
  }
};
</script>
<style scoped>
.button {
  margin-right: 0px;
  margin-bottom: 150px;
}
.backgroundImg {
  padding-top: 51px;
  height: calc(100vh - 51px);
  width: 100%;
  position: relative;
}
.backgroundImg img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderAD.vue